export default __webpack_public_path__ + "static/media/TimeClockFile.1a5e0123.svg";